import { encodeSfDict } from '../structuredfield/encodeSfDict.js';
import { prepareCmcdData } from './prepareCmcdData.js';
/**
 * Encode a CMCD object to a string.
 *
 * @param cmcd - The CMCD object to encode.
 * @param options - Options for encoding.
 *
 * @returns The encoded CMCD string.
 *
 * @group CMCD
 *
 * @beta
 *
 * @example
 * {@includeCode ../../test/cmcd/encodeCmcd.test.ts#example}
 */
export function encodeCmcd(cmcd, options = {}) {
    if (!cmcd) {
        return '';
    }
    return encodeSfDict(prepareCmcdData(cmcd, options), { whitespace: false });
}
//# sourceMappingURL=encodeCmcd.js.map